/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B1_TInputs */

const en_mk_abt_b1_t = /** @type {(inputs: Mk_Abt_B1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent needs a boss`)
};

const id_mk_abt_b1_t = /** @type {(inputs: Mk_Abt_B1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen harus punya atasan`)
};

/**
* | output |
* | --- |
* | "An agent needs a boss" |
*
* @param {Mk_Abt_B1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b1_t = /** @type {((inputs?: Mk_Abt_B1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b1_t(inputs)
	return en_mk_abt_b1_t(inputs)
});